module.exports = __webpack_public_path__ + "img/2.3.TP.c3f03e1d.png";